/**
 * Service d'authentification
 * VERSION CORRIGÉE P0 — Plus de token dans les params, cookie httpOnly
 */
import { apiService } from './api'
import type { LoginCredentials, LoginResponse, User } from '../types'

export const authService = {
  login: async (credentials: LoginCredentials) => {
    // Le backend définit les cookies httpOnly (access_token + refresh_token)
    return await apiService.post<LoginResponse>('/auth/login', credentials)
  },

  loginWith2FA: async (data: { email: string; password: string; totp_code: string }) => {
    return await apiService.post<LoginResponse>('/auth/login/2fa', data)
  },

  loginWithEmail2FA: async (data: { email: string; password: string; email_otp: string }) => {
    return await apiService.post<LoginResponse>('/auth/login/email-2fa', data)
  },

  /**
   * Rafraîchit l'access token.
   * VULN-037 CORRIGÉ : Le refresh_token est automatiquement envoyé
   * via cookie httpOnly — plus besoin de le passer en paramètre.
   */
  refreshToken: async () => {
    return await apiService.post<{ message: string }>('/auth/refresh')
  },

  logout: async () => {
    return await apiService.post('/auth/logout')
  },

  getCurrentUser: async () => {
    return await apiService.get<User>('/auth/users/me')
  },

  // ==================== PERMISSIONS RBAC ====================
  getUserPermissions: async (): Promise<{
    user_id: number
    email: string
    role: string
    role_name: string
    permissions: string[]
    is_admin: boolean
    is_super_admin: boolean
  }> => {
    return await apiService.get('/auth/me/permissions')
  },

  getUserPermissionsById: async (userId: number): Promise<{
    user_id: number
    email: string
    role: string
    role_name: string
    permissions: string[]
    is_admin: boolean
    is_super_admin: boolean
  }> => {
    return await apiService.get(`/auth/users/${userId}/permissions`)
  },
  // ==========================================================

  setup2FA: async () => {
    return await apiService.post<{ secret: string; qr_code_uri: string; backup_codes: string[] }>('/auth/2fa/setup')
  },

  enable2FA: async (data: { totp_code: string; secret: string }) => {
    return await apiService.post('/auth/2fa/enable', data)
  },

  disable2FA: async (data: { password: string; totp_code?: string }) => {
    return await apiService.post('/auth/2fa/disable', data)
  },

  updatePassword: async (data: { current_password: string; new_password: string; confirm_password: string }) => {
    return await apiService.put('/auth/users/me/password', data)
  },
}